import { render, staticRenderFns } from "./socialResponsibilyIntroduction.vue?vue&type=template&id=473db99d&"
import script from "./socialResponsibilyIntroduction.vue?vue&type=script&lang=js&"
export * from "./socialResponsibilyIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./socialResponsibilyIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports